import * as cn from "classnames";
import * as React from "react";
import "./ProportionalProgressChart.css";

export interface ProportionalProgressChartData {
    value: number;
    color: string;
    data?: any;
}

export interface ProportionalProgressChartProps {
    data: ProportionalProgressChartData[];
    onHoverDataItem?: (item: ProportionalProgressChartData, barCenter: number) => void;
    className?: string;
}

export class ProportionalProgressChart extends React.Component<ProportionalProgressChartProps> {
    private chart: HTMLDivElement | undefined;

    render() {
        const total = this.props.data.reduce((total, item) => total + item.value, 0);

        const data = this.props.data.map<{ style: React.CSSProperties; item: ProportionalProgressChartData }>(item => ({
            style: {
                flexGrow: item.value,
                flexShrink: item.value,
                flexBasis: `${((item.value / total) * 100).toFixed(4)}%`,
                backgroundColor: item.color
            },
            item
        }));

        return (
            <div className={cn("ProportionalProgressChart", this.props.className)} ref={ref => (this.chart = ref)}>
                {data.map((element, index) => (
                    <div
                        className="ProportionalProgressChart__item"
                        key={index}
                        style={element.style}
                        onMouseEnter={e => {
                            if (!this.props.onHoverDataItem) {
                                return;
                            }

                            const chartRect = this.chart ? this.chart.getBoundingClientRect() : undefined;
                            const rect = e.currentTarget.getBoundingClientRect();

                            if (chartRect && rect) {
                                const barCenter = rect ? rect.left - chartRect.left + rect.width / 2 : 0;
                                this.props.onHoverDataItem(element.item, barCenter);
                            }
                        }}
                    >
                        &nbsp;
                    </div>
                ))}
            </div>
        );
    }
}
